// extracted by mini-css-extract-plugin
export default {"headerScope":"headerScope__f2VA3"};